export const FIREFOX_VERSIONS = /Firefox\/(82|84).*/;